import * as types from './constants'

const initialState = {
  logoFile: null,
  backgroundFile: null,
  navlogoFile: null,
  faviconFile: null,
  loginLogoFile: null,
  appIconFile: null,
  theme: {
    logo: {},
    background: {},
    navlogo: {},
    loginLogo: {},
    favicon: {},
    color: '',
    navColor: '',
    navTextColor: '',
    navIconColor: '',
    topbarIconColor: '',
    sidebarBackground: '',
    sidebarActiveColor: '',
    sidebarTextColor: '',
  },
  status: '',
}

const themeConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.THEME:
      return {
        ...state,
        theme: {
          ...state.theme,
          ...action.theme,
        },
      }
    case types.THEME_IMAGE_CHANGE:
      return {
        ...state,
        [action.name]: action.value,
      }

    case types.THEME_IMAGE_FILE:
      return {
        ...state,
        [action.name]: action.value,
      }
    case types.THEME_STATUS:
      return {
        ...state,
        status: action.status,
      }
    case types.SET_THEME_COLORS:
      return {
        ...state,
        theme: {
          ...state.theme,
          [action.name]: action.value,
        },
      }
    case types.THEME_RESET:
      return initialState
    default:
      return state
  }
}

export default themeConfigReducer
